import request from "root/js/request";

export const getMPCabinets = async ({ wb_types, extra_fields, synced_types } = {}) => {
  const response = await request({
    url: "/company/mp_cabinets/",
    method: "get",
    params: {
      wb_types,
      extra_fields,
      synced_types,
    },
  });
  return response.data;
};

export const updateMPCabinet = async (cabinetId, name) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinetId}/`,
    method: "patch",
    data: { name },
  });
  return response.data;
};

export const deleteMPCabinet = async cabinetId => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinetId}/`,
    method: "delete",
  });
  return response.data;
};

export const createMPCabinet = async ({ name }) => {
  const response = await request({
    url: `/company/mp_cabinets/`,
    method: "post",
    data: { name },
  });
  return response.data;
};

export const getUrlConnectWbOauth = async ({ cabinet_id, is_demo }) => {
  const response = await request({
    url: `/company/mp_cabinets/connect_wb_oauth/`,
    method: "get",
    params: {
      cabinet_id,
      is_demo,
    },
  });
  return response.data;
};

export const getTokensByCabinetId = async ({ cabinet_id, token, types }) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinet_id}/wb_tokens/`,
    method: "get",
    data: {
      token,
      types,
    },
  });
  return response.data;
};

export const addTokenByCabinetId = async ({ cabinet_id, token, types }) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinet_id}/wb_tokens/`,
    method: "post",
    data: {
      token,
      types,
    },
  });
  return response.data;
};
export const updateTokenByCabinetId = async ({ cabinet_id, token_id, token }) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinet_id}/wb_tokens/${token_id}/`,
    method: "patch",
    data: {
      token,
    },
  });
  return response.data;
};
export const deleteTokenByCabinetId = async ({ cabinet_id, token_id }) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinet_id}/wb_tokens/${token_id}/`,
    method: "delete",
  });
  return response.data;
};

export const createWBToken = async ({ token, types }) => {
  const response = await request({
    url: `/company/mp_cabinets/submit_wb_token/`,
    method: "post",
    data: {
      token,
      types,
    },
  });
  return response.data;
};

export const getMPCabinetsOAuthRefresh = async ({ id }) => {
  const response = await request({
    url: `/company/mp_cabinets/${id}/oauth_refresh/`,
    method: "get",
  });
  return response.data;
};

export const deleteTokenOAuthByCabinetId = async ({ cabinet_id }) => {
  const response = await request({
    url: `/company/mp_cabinets/${cabinet_id}/wb_oauth/`,
    method: "delete",
  });
  return response.data;
};
